import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            position: "relative",
            minWidth: '50px',
            minHeight: '35px',
        },
        iconFilter: {
            position: 'absolute',
            left: '0',
            borderRadius: '0',
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
            '& svg': {
                width: 30,
                height: 30,
                '& path': {
                    fill: colors.color19
                },
            },
            '& .MuiBadge-badge': {
                top: -3,
                right: 3,
                background: colors.color19,
            },
        },
    }
}
